"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Control;
(function (Control) {
    Control[Control["NONE"] = 0] = "NONE";
    Control[Control["EQUIPMENT_FORBID"] = 1] = "EQUIPMENT_FORBID";
    Control[Control["PASSIVE_FORBID"] = 2] = "PASSIVE_FORBID";
    Control[Control["CONFUSION"] = 3] = "CONFUSION";
    Control[Control["DIZZY"] = 4] = "DIZZY";
    Control[Control["FROZEN"] = 5] = "FROZEN";
    Control[Control["IMPRISONMENT"] = 6] = "IMPRISONMENT";
    Control[Control["POLYMORPH"] = 7] = "POLYMORPH";
    Control[Control["PROVOKE"] = 8] = "PROVOKE";
    Control[Control["SILENT"] = 9] = "SILENT";
    Control[Control["SLEEP"] = 10] = "SLEEP";
    Control[Control["SNEER"] = 11] = "SNEER";
})(Control = exports.Control || (exports.Control = {}));
// 事件代码
var EventCodes;
(function (EventCodes) {
    EventCodes[EventCodes["NONE"] = 0] = "NONE";
    EventCodes[EventCodes["BATTLE_START"] = 1] = "BATTLE_START";
    EventCodes[EventCodes["SENKI"] = 2] = "SENKI";
    EventCodes[EventCodes["TURN_START"] = 3] = "TURN_START";
    EventCodes[EventCodes["ACTION_START"] = 4] = "ACTION_START";
    EventCodes[EventCodes["ACTION_END"] = 5] = "ACTION_END";
    EventCodes[EventCodes["TURN_END"] = 6] = "TURN_END";
    EventCodes[EventCodes["TAKEN_SELECT"] = 7] = "TAKEN_SELECT";
    EventCodes[EventCodes["BUFF_GET"] = 8] = "BUFF_GET";
    EventCodes[EventCodes["BUFF_REMOVE"] = 9] = "BUFF_REMOVE";
    EventCodes[EventCodes["ADD_BUFF"] = 10] = "ADD_BUFF";
    EventCodes[EventCodes["BEFORE_BUFF_GET"] = 11] = "BEFORE_BUFF_GET";
    EventCodes[EventCodes["BEFORE_BUFF_REMOVE"] = 12] = "BEFORE_BUFF_REMOVE";
    EventCodes[EventCodes["BUFF_RES"] = 13] = "BUFF_RES";
    EventCodes[EventCodes["MANA_OVERFLOW"] = 14] = "MANA_OVERFLOW";
    EventCodes[EventCodes["MANA_CHANGE"] = 15] = "MANA_CHANGE";
    EventCodes[EventCodes["SKILL"] = 16] = "SKILL";
    EventCodes[EventCodes["BEFORE_ATTACK"] = 17] = "BEFORE_ATTACK";
    EventCodes[EventCodes["WILL_ATTACK"] = 18] = "WILL_ATTACK";
    EventCodes[EventCodes["WILL_BE_ATTACKED"] = 19] = "WILL_BE_ATTACKED";
    EventCodes[EventCodes["CRI"] = 20] = "CRI";
    EventCodes[EventCodes["WILL_DAMAGE"] = 21] = "WILL_DAMAGE";
    EventCodes[EventCodes["WILL_BE_DAMAGE"] = 22] = "WILL_BE_DAMAGE";
    EventCodes[EventCodes["HAS_DAMAGED"] = 23] = "HAS_DAMAGED";
    EventCodes[EventCodes["HAS_BEEN_DAMAGED"] = 24] = "HAS_BEEN_DAMAGED";
    EventCodes[EventCodes["HAS_ATTACKED"] = 25] = "HAS_ATTACKED";
    EventCodes[EventCodes["HAS_BEEN_ATTACKED"] = 26] = "HAS_BEEN_ATTACKED";
    EventCodes[EventCodes["DEAD"] = 27] = "DEAD";
    EventCodes[EventCodes["UPDATE_HP"] = 28] = "UPDATE_HP";
    EventCodes[EventCodes["BEFORE_HEALING"] = 29] = "BEFORE_HEALING";
    EventCodes[EventCodes["WILL_BE_HEALED"] = 30] = "WILL_BE_HEALED";
    EventCodes[EventCodes["WILL_HEAL"] = 31] = "WILL_HEAL";
    EventCodes[EventCodes["HAS_BEEN_HEALED"] = 32] = "HAS_BEEN_HEALED";
    EventCodes[EventCodes["HAS_HEALED"] = 33] = "HAS_HEALED";
})(EventCodes = exports.EventCodes || (exports.EventCodes = {}));
var AttackParams;
(function (AttackParams) {
    AttackParams["SHOULD_COMPUTE_CRI"] = "shouldComputeCri";
    AttackParams["INDIRECT"] = "Indirect";
    AttackParams["REAL"] = "Real";
    AttackParams["CRITICAL"] = "Critical";
    AttackParams["CONDUCTION"] = "Conduction";
    AttackParams["NORMAL_ATTACK"] = "NormalAttack";
    AttackParams["SINGLE"] = "Single";
    AttackParams["GROUP"] = "Group";
    AttackParams["IGNORE_SOURCE"] = "IgnoreSource";
    AttackParams["NO_SHARE"] = "NoShare";
    AttackParams["NO_SHIELD"] = "NoShield";
    AttackParams["NO_TARGET_EQUIPMENT"] = "NoTargetEquipment";
    AttackParams["NO_TARGET_PASSIVE"] = "NoTargetPassive";
    AttackParams["NO_SOURCE_EQUIPMENT"] = "NoSourceEquipment";
    AttackParams["NO_SOURCE_PASSIVE"] = "NoSourcePassive"; // 不触发御魂
})(AttackParams = exports.AttackParams || (exports.AttackParams = {}));
var BuffParams;
(function (BuffParams) {
    BuffParams["NO_DISPEL"] = "CanDispel";
    BuffParams["NO_REMOVE"] = "CanRemove";
    BuffParams["STAMP"] = "Stamp";
    BuffParams["ENCHANTMENT"] = "Enchantment";
    BuffParams["FAIRYLAND"] = "fairyland";
    BuffParams["BUFF"] = "Buff";
    BuffParams["DEBUFF"] = "Debuff";
    BuffParams["DEPEND_ON"] = "DependOn";
    BuffParams["COUNT_DOWN"] = "CountDown";
    BuffParams["COUNT_DOWN_BY_SOURCE"] = "CountDownBySource";
    BuffParams["VISIBLE"] = "Visible";
    BuffParams["CONTROL"] = "Control";
    BuffParams["AFFECT_PROPERTY"] = "AffectProperty";
    BuffParams["SHIELD"] = "Shield";
    BuffParams["SHOULD_COMPUTE_PROBABILITY"] = "ShouldComputeProbability";
    BuffParams["RULE_HIGH_AND_DRY"] = "RuleIighAndDry";
    BuffParams["RULE_CONTROL_IMMUNE"] = "RuleControlImmune";
})(BuffParams = exports.BuffParams || (exports.BuffParams = {}));
var HealingParams;
(function (HealingParams) {
    HealingParams["CRITICAL"] = "Critical";
    HealingParams["SHOULD_COMPUTE_CRI"] = "shouldComputeCri";
})(HealingParams = exports.HealingParams || (exports.HealingParams = {}));
// 式神可变属性
exports.BattleProperties = {
    MAX_HP: 'max_hp',
    ATK: 'atk',
    DEF: 'def',
    SPD: 'spd',
    CRI: 'cri',
    CRI_DMG: 'cri_dmg',
    EFT_HIT: 'eft_hit',
    EFT_RES: 'eft_res',
    DMG_DEALT_B: 'dmg_dealt_buff',
    DMG_DEALT_D: 'dmg_dealt_debuff',
    DMG_TAKEN_B: 'dmg_taken_buff',
    DMG_TAKEN_D: 'dmg_taken_debuff',
    DEF_NEG: 'def_neg',
    DEF_NEG_P: 'def_neg_p',
    HP_STEAL: 'hp_steal',
    HEALING_DOWN: 'healing_down',
    HEALING_UP: 'healing_up',
};
// 原因
var Reasons;
(function (Reasons) {
    Reasons[Reasons["NOTHING"] = 0] = "NOTHING";
    Reasons[Reasons["SKILL"] = 1] = "SKILL";
    Reasons[Reasons["TIME_OUT"] = 2] = "TIME_OUT";
    Reasons[Reasons["COST"] = 3] = "COST";
    Reasons[Reasons["MANA_PROGRESS"] = 4] = "MANA_PROGRESS";
    Reasons[Reasons["RULE"] = 5] = "RULE";
})(Reasons = exports.Reasons || (exports.Reasons = {}));
var EventRange;
(function (EventRange) {
    EventRange[EventRange["NONE"] = 0] = "NONE";
    EventRange[EventRange["SELF"] = 1] = "SELF";
    EventRange[EventRange["TEAM"] = 2] = "TEAM";
    EventRange[EventRange["ENEMY"] = 3] = "ENEMY";
})(EventRange = exports.EventRange || (exports.EventRange = {}));
